import React from 'react'
import PropTypes from 'prop-types'
import { Item } from './.'
import { CurrencyLabel } from 'Shared/CurrencyLabel'

const Balance = ({
  totalizers: { onHold },
  balance: { pointsValue },
  currency
}) => (
  <div className='extract-points-content pb-2 mb-2 border-bottom-dashed border-color-ui-2'>
    <p>{`Saldo de ${currency.label}`}</p>
    <div className='extract-items'>
      <Item description='Disponível' className='available-points'>
        <CurrencyLabel value={pointsValue} {...currency} />
      </Item>
      <Item description='Resgate em Processamento' className='processing-points'>
        <CurrencyLabel value={onHold} {...currency} />
      </Item>
      <Item description='Total' className='total-points'>
        <CurrencyLabel value={pointsValue + onHold} {...currency} />
      </Item>
    </div>
  </div>
)

Balance.propTypes = {
  currency: PropTypes.object.isRequired,
  balance: PropTypes.shape({ pointsValue: PropTypes.number.isRequired })
    .isRequired,
  totalizers: PropTypes.shape({ onHold: PropTypes.number.isRequired })
    .isRequired
}

export default Balance



// WEBPACK FOOTER //
// ./src/Participant/Extract/Totalizers/Balance.js